import 'uikitcss';
import UIkit from 'uikit';
import Icons from './../../../node_modules/uikit/dist/js/uikit-icons.min.js';

UIkit.use(Icons);

import './index.less';
import Toast from 'components/toast';

export function init(mensagemErro: string, mensagemSucesso: string) {
    if (mensagemErro)
        Toast.error(mensagemErro);
    else if (mensagemSucesso)
        Toast.success(mensagemSucesso);
}
